module.exports = __webpack_public_path__ + "img/horizontal_7_3_9006.173df517.png";